export default function controlPanel(status) {
  // const list_panel = Array.from(
  //   document.getElementsByClassName("popup-content-panel")
  // );
  // list_panel.forEach((item, index) => {
  //   item.style.display = status || "none";
  // });
  document.documentElement.removeAttribute("style");
  //   document.documentElement.style.overflow = "auto";
}
